module.exports = __webpack_public_path__ + "static/media/LB-Logo.58f48425.png";